import styled from 'styled-components';

export const Layer = styled.div`
display: flex;
justify-content: flex-start;
align-items: center;
height: 32px;
p{
  font-size: 12px;
  width: 130px;
  font-weight: 500;
  margin-left: 5px;
}

`